import {bzIconChevronDown, bzIconChevronUp} from "@bringoz/ui/icons";

require("./bringoz-table-columns-settings.scss");

import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";

export interface TableColumnSetting {
  enabled?: boolean;
  order?: number;
  permission?: string | string[];
  hide?: boolean;
}

export type TableColumnsSettings = Record<string, TableColumnSetting>;

@Component({
  selector: "app-bringoz-table-columns-settings",
  templateUrl: "./bringoz-table-columns-settings.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BringozTableColumnsSettingsComponent {
  readonly columns = input<TableColumnsSettings>({});
  readonly title = input<string>();
  readonly isOpen = input(false);
  readonly columnsTranslationPrefix = input<string>();

  readonly columnsChange = output<TableColumnsSettings>();

  readonly chevronUp = bzIconChevronUp;
  readonly chevronDown = bzIconChevronDown;

  readonly entries = computed(() =>
    Object.entries(this.columns() ?? {})
      .filter(([, column]) => !column.hide)
      .map(([key, column]) => ({
        key,
        column,
        labelKey: this.columnsTranslationPrefix() ? `${this.columnsTranslationPrefix()}.${key}` : key,
      })));

  onToggle(column: TableColumnSetting, enabled: boolean): void {
    column.enabled = enabled;
    this.columnsChange.emit(this.columns());
  }
}
